import React from 'react';
import { useMessage } from '@tmapy/intl';

import { SuccessBadge, DangerBadge } from '@tmapy/style-guide';

import { stateMessages } from './svuMessages';
import { UrcenyEditorZpsStatesEnum } from '../../openapi/types/UrcenyEditorZpsStatesEnum';

type StateBadgeProps = {
  state: UrcenyEditorZpsStatesEnum;
};

export const StateBadge: React.FC<StateBadgeProps> = ({ state }) => {
  const formatMessage = useMessage();
  const stateText = formatMessage.lookup(stateMessages, state);

  switch (state) {
    // SUCCESS
    case UrcenyEditorZpsStatesEnum.CHANGE_AREA_ACCEPTED:
    case UrcenyEditorZpsStatesEnum.SET_EDITOR_ACCEPTED: {
      return <SuccessBadge>{stateText}</SuccessBadge>;
    }
    // SUCCESS STRONG
    case UrcenyEditorZpsStatesEnum.CHANGE_AREA_RECEIVING:
    case UrcenyEditorZpsStatesEnum.CHANGE_AREA_SENDING:
    case UrcenyEditorZpsStatesEnum.PREPARED_TO_SEND:
    case UrcenyEditorZpsStatesEnum.SET_EDITOR_RECEIVING:
    case UrcenyEditorZpsStatesEnum.SET_EDITOR_SENDING: {
      return <SuccessBadge isStrong>{stateText}</SuccessBadge>;
    }
    // DANGER
    case UrcenyEditorZpsStatesEnum.REVOKE_AREA_FAILED:
    case UrcenyEditorZpsStatesEnum.CHANGE_AREA_RECEIVING_FAILED:
    case UrcenyEditorZpsStatesEnum.CHANGE_AREA_SENDING_FAILED:
    case UrcenyEditorZpsStatesEnum.SET_EDITOR_RECEIVING_FAILED:
    case UrcenyEditorZpsStatesEnum.SET_EDITOR_SENDING_FAILED: {
      return <DangerBadge>{stateText}</DangerBadge>;
    }
    // DANGER STRONG
    case UrcenyEditorZpsStatesEnum.CHANGE_AREA_REJECTED:
    case UrcenyEditorZpsStatesEnum.SET_EDITOR_REJECTED: {
      return <DangerBadge isStrong>{stateText}</DangerBadge>;
    }
    // DEFAULT
    default: {
      console.error('StateBadge: Unknown state', state);
      return state;
    }
  }
};
